// The marketplace schema types handle as a plain string, so an empty one parses; a blank row
// label is worse than a dash.
export const formatHandle = (handle?: string | null): string => handle || '—';
